import { CHAT_MESSAGE_TYPES, MORPHEUS_USER_ID } from 'features/chat/config';
import { Messages } from 'features/chat/config/types/Message';
import { useHasKeywords } from 'features/chat/hooks/useHasKeywords';

const LAST_MESSAGES_TO_CHECK_FOR_MORPHEUS = 3;

export const useGlowingMessageIds = (messages: Messages) => {
  // should return 3 last plain messages
  const lastMessages: Messages = [];
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (message.type === CHAT_MESSAGE_TYPES.PLAIN) {
      // @ts-ignore
      lastMessages.push(message);
    }
    if (lastMessages.length === LAST_MESSAGES_TO_CHECK_FOR_MORPHEUS) {
      break;
    }
  }

  const hasKeywords = useHasKeywords();

  // Check if a message was replied to by Morpheus
  const hasBeenRepliedByMorpheus = (messageId: string): boolean => {
    return messages.some(
      (msg) =>
        msg.fromUserId === MORPHEUS_USER_ID &&
        msg.replyToMessage?.messageId === messageId
    );
  };

  return lastMessages
    .filter((message) => {
      const hasKeyword = hasKeywords(message.text);
      const repliedByMorpheus = hasBeenRepliedByMorpheus(message.messageId);

      return hasKeyword && !repliedByMorpheus;
    })
    .map((message) => message.messageId);
};
